import { render, staticRenderFns } from "./nav-drawer.vue?vue&type=template&id=5b451b34&"
import script from "./nav-drawer.vue?vue&type=script&lang=js&"
export * from "./nav-drawer.vue?vue&type=script&lang=js&"
import style0 from "./nav-drawer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports